import styled, { keyframes } from 'styled-components'

export const Wrap = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: block;
`

export const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
`

const shimmer = keyframes`
  0% { background-position: 100% 0; }
  100% { background-position: 0 0; }
`

// img 위에 덮는 오버레이(로드 완료 전까지). img를 교체하지 않으므로 다운로드가 취소되지 않는다.
export const Skeleton = styled.div`
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: linear-gradient(90deg, #eceef2 25%, #e2e5ea 37%, #eceef2 63%);
  background-size: 400% 100%;
  animation: ${shimmer} 1.4s ease infinite;
  pointer-events: none;
`

export const Fallback = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px;
  box-sizing: border-box;
  background: #eceef2;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: inherit;
`

export const FallbackIcon = styled.svg`
  width: 36px;
  height: 36px;
  fill: rgba(0, 0, 0, 0.32);
  flex-shrink: 0;
`

export const FallbackTitle = styled.p`
  margin: 0;
  font-size: 11px;
  line-height: 1.3;
  color: rgba(0, 0, 0, 0.55);
  text-align: center;
  word-break: break-word;
  max-width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`
